<template>
        <div class="uk-modal uk-open" style="display: block;z-index:999999999;" v-if="mes">
            <div class="uk-modal-dialog">
                <h3>{{$t('common.networkerror')}}</h3>
                <hr>
                <p class="uk-text-right">                    
                    <a class="uk-button uk-button-default" @click="close">{{$t('common.close')}}</a>
                    <a class="uk-button uk-button-primary" @click="isReload">{{$t('common.refresh')}}</a>
                </p>
            </div>
        </div>
</template>
<script>
export default {
    name: 'mes',
    data() {
        return {
            
        }
    },   
    computed:{
      mes(){
        return this.$store.state.loading.mes
      }
    },
    methods:{
        isReload(){
            this.$store.dispatch('closeMes',2);            
            window.location.reload();
        },
        close(){
            this.$store.dispatch('closeMes',2);            

        }       
    }
}
</script>
<style scoped lang="scss">
.uk-overlay-panel{ position:fixed;  }
.uk-overlay-panel-loading{z-index: 99999;}
.uk-overlay-panel-waiting{background:#fff;z-index: 99990; }
.loading{ width:120px; height:120px; line-height:120px; color:#fff; background:rgba(0,0,0,.8); font-size:30px; border-radius:10px; text-align:center; position:relative;}
.loading p{ position:absolute; left:0;bottom:0;right:0; color:#fff; line-height:60px;}
</style>


// WEBPACK FOOTER //
// src/components/common/mes.vue